import { LocationType } from "../../types/locationType";
import { UserRoleTypeType } from "../../types/userType";

export type ResponseUserType = {
  first_name: string;
  last_name: string;
  adp_auth_num: string;
  phone: string;
  confirmed: boolean;
  blocked: boolean;
  email: string;
  id: string;
  locations: LocationType[];
  username: string;
  __typename?: string;
  role: {
    id: string;
    description: string;
    type: UserRoleTypeType;
    name: string;
    __typename?: string;
  };
  password_updated_at: string;
  mfa_enabled: boolean;
};

export const sanitizeUser = (responseUser: ResponseUserType) => {
  const {
    first_name,
    last_name,
    adp_auth_num,
    phone,
    confirmed,
    blocked,
    email,
    id,
    username,
    role: {
      id: roleId,
      description: roleDescription,
      type: roleType,
      name: roleName,
    },
    locations,
    password_updated_at,
    mfa_enabled
  } = responseUser;

  return {
    first_name,
    last_name,
    adp_auth_num,
    phone,
    confirmed,
    blocked,
    email,
    id,
    username,
    role: {
      id: roleId,
      description: roleDescription,
      type: roleType,
      name: roleName,
    },
    locations,
    password_updated_at,
    mfa_enabled
  };
};
